import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateAutoTemplateMutation,
  CreateAutoTemplateMutationVariables,
  CopyAutoTemplateMutation,
  CopyAutoTemplateMutationVariables,
  UploadPdfAndExtractTextMutation,
  UploadPdfAndExtractTextMutationVariables,
  UpdateAutoTemplateMutation,
  UpdateAutoTemplateMutationVariables,
  DeleteAutoTemplateMutation,
  DeleteAutoTemplateMutationVariables,
  CreateTemplatePreviewMutation,
  CreateTemplatePreviewMutationVariables,
  SetTeamDefaultTemplateMutation,
  SetTeamDefaultTemplateMutationVariables,
  RemoveTeamDefaultTemplateMutation,
  RemoveTeamDefaultTemplateMutationVariables,
  SetOrganizationDefaultTemplateMutation,
  SetOrganizationDefaultTemplateMutationVariables,
  RemoveOrganizationDefaultTemplateMutation,
  RemoveOrganizationDefaultTemplateMutationVariables,
} from "./AutoTemplates.generated";

export const CREATE_AUTO_TEMPLATE: TypedDocumentNode<
  CreateAutoTemplateMutation,
  CreateAutoTemplateMutationVariables
> = gql`
  mutation CreateAutoTemplate(
    $createTemplateInput: CreateAutoTemplateInput!
  ) {
    createAutoTemplate(createTemplateInput: $createTemplateInput) {
      ok
      templateUuid
    }
  }
`;

export const COPY_AUTO_TEMPLATE: TypedDocumentNode<
  CopyAutoTemplateMutation,
  CopyAutoTemplateMutationVariables
> = gql`
  mutation CopyAutoTemplate($templateUuid: String!, $name: String) {
    copyAutoTemplate(templateUuid: $templateUuid, name: $name) {
      ok
      templateUuid
    }
  }
`;

export const UPLOAD_PDF_AND_EXTRACT_TEXT: TypedDocumentNode<
  UploadPdfAndExtractTextMutation,
  UploadPdfAndExtractTextMutationVariables
> = gql`
  mutation UploadPdfAndExtractText(
    $storageObjectName: String!
    $templateType: String!
    $templateUuid: String
  ) {
    uploadPdfAndExtractText(
      storageObjectName: $storageObjectName
      templateType: $templateType
      templateUuid: $templateUuid
    ) {
      SUBJECTIVE
      OBJECTIVE
      ASSESSMENT
      PLAN
      CUSTOM
    }
  }
`;

export const UPDATE_AUTO_TEMPLATE: TypedDocumentNode<
  UpdateAutoTemplateMutation,
  UpdateAutoTemplateMutationVariables
> = gql`
  mutation UpdateAutoTemplate($input: UpdateAutoTemplateInput!) {
    updateAutoTemplate(updateTemplateInput: $input) {
      ok
    }
  }
`;
export const DELETE_AUTO_TEMPLATE: TypedDocumentNode<
  DeleteAutoTemplateMutation,
  DeleteAutoTemplateMutationVariables
> = gql`
  mutation DeleteAutoTemplate($templateUuid: String!) {
    deleteAutoTemplate(templateUuid: $templateUuid) {
      ok
    }
  }
`;

export const CREATE_TEMPLATE_PREVIEW: TypedDocumentNode<
  CreateTemplatePreviewMutation,
  CreateTemplatePreviewMutationVariables
> = gql`
  mutation CreateTemplatePreview(
    $createTemplatePreviewInput: TemplatePreviewInput!
  ) {
    createTemplatePreview(
      createTemplatePreviewInput: $createTemplatePreviewInput
    ) {
      ok
    }
  }
`;

export const SET_TEAM_DEFAULT_TEMPLATE: TypedDocumentNode<
  SetTeamDefaultTemplateMutation,
  SetTeamDefaultTemplateMutationVariables
> = gql`
  mutation SetTeamDefaultTemplate(
    $templateUuid: String!
    $teamUuids: [String!]!
  ) {
    setTeamDefaultTemplate(
      templateUuid: $templateUuid
      teamUuids: $teamUuids
    ) {
      ok
    }
  }
`;

export const REMOVE_TEAM_DEFAULT_TEMPLATE: TypedDocumentNode<
  RemoveTeamDefaultTemplateMutation,
  RemoveTeamDefaultTemplateMutationVariables
> = gql`
  mutation RemoveTeamDefaultTemplate(
    $templateUuid: String!
    $teamUuids: [String!]!
  ) {
    removeTeamDefaultTemplate(
      templateUuid: $templateUuid
      teamUuids: $teamUuids
    ) {
      ok
    }
  }
`;

export const SET_ORGANIZATION_DEFAULT_TEMPLATE: TypedDocumentNode<
  SetOrganizationDefaultTemplateMutation,
  SetOrganizationDefaultTemplateMutationVariables
> = gql`
  mutation SetOrganizationDefaultTemplate(
    $templateUuid: String!
    $orgUuid: String!
  ) {
    setOrganizationDefaultTemplate(
      templateUuid: $templateUuid
      orgUuid: $orgUuid
    ) {
      ok
    }
  }
`;

export const REMOVE_ORGANIZATION_DEFAULT_TEMPLATE: TypedDocumentNode<
  RemoveOrganizationDefaultTemplateMutation,
  RemoveOrganizationDefaultTemplateMutationVariables
> = gql`
  mutation RemoveOrganizationDefaultTemplate(
    $templateUuid: String!
    $orgUuid: String!
  ) {
    removeOrganizationDefaultTemplate(
      templateUuid: $templateUuid
      orgUuid: $orgUuid
    ) {
      ok
    }
  }
`;
